/**
 * 행운권 로또 누적 상금 게이지 파생.
 * 트랙은 목표금액보다 길게 잡아(헤드룸) 목표 지점 마커가 트랙 중간(~71%)에 오고,
 * 누적 금액이 목표를 초과해도 채움이 마커를 넘어가는 것으로 시각화한다(Figma 9756-23026).
 */
const BAR_HEADROOM_RATIO = 1.4;

export interface LottoPotGaugeState {
  /** 누적 금액 채움 비율(0~100) */
  fillPercent: number;
  /** 목표금액 지점 마커 위치(0~100) */
  goalPercent: number;
  /** 마커 하단 라벨 — 미달이면 목표금액, 도달하면 달성 문구 */
  goalLabel: string;
}

export const resolveLottoPotGauge = ({
  accumulatedAmount,
  targetAmount,
}: {
  accumulatedAmount: number;
  targetAmount: number;
}): LottoPotGaugeState => {
  const goalPercent = Math.round((100 / BAR_HEADROOM_RATIO) * 10) / 10;

  if (targetAmount <= 0) {
    return { fillPercent: 0, goalPercent, goalLabel: '-' };
  }

  const barMaxAmount = targetAmount * BAR_HEADROOM_RATIO;
  const fillRatio = Math.max(0, Math.min(1, accumulatedAmount / barMaxAmount));

  return {
    fillPercent: Math.round(fillRatio * 1000) / 10,
    goalPercent,
    goalLabel:
      accumulatedAmount >= targetAmount
        ? '목표금액 달성'
        : `${targetAmount.toLocaleString()}원`,
  };
};
